/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sidebar-collapse[_ngcontent-%COMP%]{scroll-behavior:smooth}"];
export { styles as styles };
